<template>
    <section class="mt-16">
        <v-row>
            <v-col cols="12" offset="0" md="10" offset-md="1">
                <v-breadcrumbs
                large
                :items="crumbs"
                divider="/"
                class="pl-0"
                ></v-breadcrumbs>
        
                <h1 class="primary--text">
                <v-icon color="primary">mdi-shield-account</v-icon> <span>Gestão de Garantias</span>
                </h1>
                <v-icon color="primary">
                mdi-eye
                </v-icon><v-icon class="ml-2" small>mdi-forward</v-icon>
                Visualizar
        
                <v-icon color="red" class="ml-4">
                mdi-delete
                </v-icon><v-icon class="ml-2" small>mdi-forward</v-icon>
                Remover
        
                <div style="position:relative">
                <v-container>
                    <v-speed-dial
                    absolute
                    v-model="speedDial"
                    top
                    right
                    direction="bottom"
                    :open-on-hover="true"
                    >
                    <template v-slot:activator>
                        <v-tooltip right color="primary">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                            v-bind="attrs" v-on="on"
                            v-model="speedDial"
                            color="primary"
                            dark
                            x-large
                            fab
                            >
                            <v-icon v-if="speedDial">
                                mdi-close
                            </v-icon>
                            <v-icon v-else>
                                mdi-dots-vertical
                            </v-icon>
                            </v-btn>
                        </template>
                        <span>Opções</span>
                        </v-tooltip>
                    </template>
                    <v-tooltip right color="info">
                        <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs" v-on="on"
                            fab
                            dark
                            small
                            color="info"
                            large
                            @click="searching = true"
                        >
                            <v-icon>mdi-filter</v-icon>
                        </v-btn>
                        </template>
                        <span>Pesquisar</span>
                    </v-tooltip>
                    <v-tooltip right color="secondary">
                        <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs" v-on="on"
                            fab
                            dark
                            small
                            color="secondary"
                            large
                            to="/garantias/obras/create"
                            v-if="$store.getters.hasPermission(['super', 'guarantees.create'])"
                        >
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                        </template>
                        <span>Registar</span>
                    </v-tooltip>
                    </v-speed-dial>
                </v-container>
        
                <v-data-table
                    :headers="headers"
                    :items="items"
                    :server-items-length="total"
                    :loading="loading"
                    :footer-props="tableFooter"
                    :options.sync="options"
                    class="mt-16"
                    locale="pt-pt"
                >
                    <template v-slot:item.sharepoint_link="{item}">
                      <span v-if="item.sharepoint_link == null">-</span>
                      <span @click="openSharepoint(item)" style="cursor: pointer;" class="text-decoration-underline" v-else>Aceder</span>
                    </template>
                    <template v-slot:item.actions="{item}">
                      <IconView
                          class="mr-2"
                          @click="viewGuarantee(item)"
                      />
                      <IconRemove
                          class="mr-2"
                          @on-submit="deleteGuarantee(item)"
                      />
                    </template>
                </v-data-table>
                </div>
                <v-navigation-drawer
                    fixed
                    right
                    v-model="searching"
                    hide-overlay
                    width="520"
                    class="pt-6"
                >
                <v-list>
                    <v-list-item>
                    <v-btn fab small color="secondary" @click="searching = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
        
                    <v-btn absolute right small color="error" @click="resetGuarantee">
                        Limpar Campos
                    </v-btn>
                    </v-list-item>
                </v-list>
                <v-list class="pt-10">
                    <v-form @submit.prevent="searchGuarantees">
                    
                      <v-list-item>
                        <v-text-field
                          v-model="filter.code"
                          prepend-inner-icon="mdi-account-details"
                          label="Code"
                          clearable
                        ></v-text-field>
                      </v-list-item>

                      <v-list-item>
                        <v-text-field
                          v-model="filter.name"
                          prepend-inner-icon="mdi-account-details"
                          label="Nome"
                          clearable
                        ></v-text-field>
                      </v-list-item>

                      <v-list-item>
                        <v-text-field
                          v-model="filter.sharepoint_link"
                          prepend-inner-icon="mdi-account-details"
                          label="Sharepoint"
                          clearable
                        ></v-text-field>
                      </v-list-item>
                    
                    <v-row
                        class="mt-10"
                        align="center"
                        justify="space-around"
                    >
                    <v-btn
                        color="primary"
                        type="submit"
                    >
                        Pesquisar
                    </v-btn>
                    </v-row>
                    </v-form>
                </v-list>
                </v-navigation-drawer>
            </v-col>
        </v-row>
    </section>
  </template>
  <script>
  import IconRemove from '@/components/UI/IconRemove.vue';
  import IconView from '@/components/UI/IconView.vue';
  import GarantiasObras from "@/api/GarantiasObras.js";
  
  export default {
    components: {
      IconRemove,
      IconView
    },
    watch: {
      'options': {
        immediate: false,
        handler () {
          setTimeout(() => {this.searchGuarantees()}, 10);
        },
        deep: true,
      },
    },
    data: () => ({
      headers: [
        {
          text: 'Código',
          sortable: true,
          value: 'code',
        },
        {
          text: 'Nome',
          sortable: true,
          value: 'name',
        },
        {
          text: 'Tipo',
          sortable: true,
          value: 'tipo_obra.tipo',
        },
        {
          text: 'Sharepoint',
          sortable: true,
          value: 'sharepoint_link',
        },
        { 
          text: 'Opções', 
          value: 'actions', 
          sortable: false 
        },
      ],
      items: [],
      total: 0,
      loading: false,
      searching: false,
      tableFooter: {
        'items-per-page-options': [5, 10, 15, 20],
        'items-per-page-text': "Linhas por página"
      },
      options: {},
      speedDial:false,
      filter: {
        name: null,
        display_name: null
      },
      users:[]
    }),
    mounted(){
  
      if(!this.$store.getters.hasPermission(["super", "guarantees.read"])) {
        this.$router.push('/admin');
      }
  
  
      this.fillBaseData();
    },
    methods:{
      openSharepoint(item){
        window.open(item.sharepoint_link, '_blank')
      },
      fillBaseData() {
  
        if(localStorage["guarantees-obras-" + this.$store.state.user.data.id] != undefined){
  
          let data = JSON.parse(localStorage["guarantees-obras-" + this.$store.state.user.data.id]);
  
          this.filter = data.filter;
  
          this.options = data.options;
        }
      },
      searchGuarantees(event){
        if(!!event && event.type == 'submit'){
          this.options.page = 1;
        }
  
        this.loading = true;
  
        let filter = {...this.filter};
  
        let request = {
          sortBy: this.options.sortBy,
          sortDesc: this.options.sortDesc,
          page: this.options.page,
          limit: this.options.itemsPerPage,
        };
      
        Object.assign(request, filter);
  
        localStorage["guarantees-obras-" + this.$store.state.user.data.id] = JSON.stringify({
          filter: this.filter,
          options: this.options,
        });
  
        GarantiasObras.search(request).then(response => {
          
          let data = response.data;
  
          this.total = data.total;
  
          this.items = data.data.map((item) => {
  
            this.searching = false;
  
            return item;
          });
  
          this.loading = false;
  
        });
      },
      resetGuarantee()
      {
        this.filter = {};
  
        this.searchGuarantees();
      },
      viewGuarantee(item){
        this.$router.push('/garantias/obras/' + item.id);
      },
      deleteGuarantee(item){
        GarantiasObras.deleteObraGuarantee(item.id)
          .then(() => {
            this.searchGuarantees();
          });
      },
    },
    computed: {
      crumbs: function() {
        return [
          {
            text: 'Dashboard',
            disabled: false,
            to: '/admin',
            exact: true,
          },
          {
            text: 'Gestão de Garantias',
            disabled: true,
            to: window.location.href,
            exact: true,
          },
        ];
      }
    }
  };
  </script>
  